// trends component
import React from "react";
import { DashBoardComponentProps, MeasurementPoint } from "../data/data";
import { MeasureData } from "../../utils/interfaces";
import { MeasurementCard } from "../../../lovable/components/MeasurementCard";
import { BodyFatCategory, getBodyFatTable } from "../data/bodyfatTable";
import { Range } from "../../../lovable/components/BodyFatIndicator";
import { currentConfig } from "../../../common/domainConfig";
interface MeasurementHolder {
    title: string;
    expanded: boolean;
    values: MeasurementPoint[];
}
export const toRanges = (table: BodyFatCategory[]):Range[] => {
    return table.map((c) => {
      return {
        label: c.cat,
        min: c.min,
        max: c.max,
        color: c.color ?? "gray",
      };
    });
  }
export const Trends: React.FC<DashBoardComponentProps> = ({ clientData, measurementDatas }) => {
    
 const  ranges = toRanges(getBodyFatTable(
    clientData.gender,
    clientData.age));
    const showTitle = (title: string) => {
    if (title === "body_fat") {
      return "Body Fat";
    }
    const showName = title
      .split("_")
      .map((s) => s.charAt(0).toUpperCase() + s.slice(1))[0];
    return showName;
  };
  function unit(title: string): string {
    switch (title) {
      case "body_fat":
        return "%";
      case "weight":
        return "kg";
      case "waist":
      case "waist_female":
      case "neck":
      case "buttocks":
      case "chest":
      case "leg_circ":
      case "arm_circ":
        return "cm";
      default:
        return "";
    }
  }

  const loadData =  ():MeasurementHolder[] => {
    
    if (!clientData.gender || !clientData.age) {
      console.error("Client data is incomplete");
      return [];
    }
  

    // sort the measurement data by createdAt date
    const measurements: MeasureData[] = [...measurementDatas].sort((a, b) => {
      return new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime();
    });
    const measurementsToShow = currentConfig.measurements[clientData.gender] || [];

    return measurementsToShow.map((m, i) => {
        return {
          title: m.label,
          expanded: false,
          values: measurements
            .map((d) => {
              const key = m.key as keyof MeasureData["measurements"];
              const value = d.measurements[key] ?? 0;
              return { id: i + "", date: new Date(d.createdAt), value: value };
            })
            .filter((d) => d.value !== 0),
        };
      }
    );
  };
  const meas = loadData();
 
  return (
    <div className="md:col-span-2">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {meas
          .filter((m) => m.values.length > 0)
          .map((measurement) => {
            return (
              <MeasurementCard
                key={measurement.title}
                myTarget={clientData?.target?.measurements['body_fat']}
                title={showTitle(measurement.title)}
                values={measurement.values.map((v) => {
                  return { id: v.id, value: Math.round(v.value), date: v.date };
                })}
                ranges={ranges}
                value={Math.round(
                  measurement.values[measurement.values.length - 1].value
                )}
                unit={unit(measurement.title)}
                change={Math.round(
                  measurement.values[measurement.values.length - 1].value -
                    measurement.values[0].value
                )}
              ></MeasurementCard>
            );
          })}
      </div>
    </div>
  );
};
